var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGainChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 45,
    viewBox: "0 0 156 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48096962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M22.1603 29.891C14.1832 31.3535 8.68556 40.054 2 41.4809V45H154V23.769C146.557 23.769 145.564 30.2534 142.062 28.4684C138.559 26.6834 134.88 14.4105 130.794 15.0596C126.708 15.7087 124.465 -1.51482 115.855 0.107925C107.245 1.73067 100.908 20.2649 94.0488 12.3135C87.1898 4.36207 85.7319 8.55761 78.4351 6.93487C71.1383 5.31212 67.9418 24.7517 61.0305 24.1305C54.1193 23.5093 52.2744 39.6779 45.2214 38.1782C36.6746 36.361 37.4186 35.3431 33.6183 32.9859C29.8181 30.6286 26.412 29.1116 22.1603 29.891Z",
    fill: "#C8E9C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M2 42.7141C8.68556 41.299 14.1832 32.6693 22.1603 31.2188C26.412 30.4456 29.8181 31.9503 33.6183 34.2884C37.4186 36.6264 36.6746 37.636 45.2214 39.4384C52.2744 40.9259 54.1193 24.889 61.0305 25.5052C67.9418 26.1213 71.1383 6.84013 78.4351 8.44965C85.7319 10.0592 87.1898 5.89781 94.0488 13.7845C100.908 21.6711 107.245 3.28785 115.855 1.67833C124.465 0.0688151 126.708 17.152 130.794 16.5082C134.88 15.8644 138.559 28.0372 142.062 29.8077C145.564 31.5782 146.557 25.1466 154 25.1466",
    stroke: "#4CB944",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGainChart);
export default __webpack_public_path__ + "static/media/gain-chart.ba6ece5f6be794c59371e3b53ee44570.svg";
export { ForwardRef as ReactComponent };